import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/Blog.css';
import '../../CSS/App.css';

const CapyJumpBlog = () => {
  return (
    <div className="blog-container">
      <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

      <p className="blog-post-title">Capy Jump</p>
      <p className="blog-meta">Godot · GDScript · Game Dev</p>

      <div className="blog-body">
        <p>
          I wanted to try making a game in Godot, but I didn't want my first project to become some giant game
          that I would never actually finish. Flappy Bird seemed perfect because the entire game is basically
          one button and one mechanic, but there's still enough there to learn how making a game actually
          works.
        </p>
        <p>
          I also made the player a capybara because why not.
        </p>

        <h2>Why Godot</h2>
        <p>
          I originally thought about using Unity since I had messed around with it before, but after all of
          the licensing stuff that happened with Unity I wanted to try something else. Godot is open source,
          lightweight, and GDScript was really easy to understand since it feels a lot like Python.
        </p>
        <p>
          For a small game like this there wasn't really a reason for me to use anything more complicated.
        </p>

        <h2>Making the Game</h2>
        <p>
          The basic game wasn't actually that difficult to make. You press a button, the capybara jumps,
          gravity pulls it back down, pipes move toward you, and touching one kills you.
        </p>
        <p>
          What took way longer than I expected was making it actually feel right.
        </p>
        <p>
          Flappy Bird looks extremely simple, but changing one number can make the entire game feel terrible.
          If the jump is too strong it feels weird. If gravity is too strong you barely have any control. If
          the pipes are too far apart the game becomes ridiculously easy, but moving them a little too close
          together makes it frustrating.
        </p>
        <p>
          I probably spent more time changing numbers and replaying the game than I did actually writing the
          code.
        </p>

        <h2>Publishing It</h2>
        <p>
          Godot can export games to the web pretty easily, so once it was finished I put it on itch.io.
        </p>
        <p>
          It's obviously not some huge commercial game or anything, but there's something satisfying about
          actually finishing a game and putting it somewhere that another person can play it. A lot of
          programming projects just sit in a folder when you're done with them, so having something
          immediately playable made this one feel different.
        </p>
      </div>
    </div>
  );
};

export default CapyJumpBlog;
